module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "section section-white"
  }, [_c('draggable', {
    staticClass: "components-view",
    attrs: {
      "options": _vm.dragIssuesOptions
    },
    on: {
      "start": _vm.onStart,
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.initData),
      callback: function($$v) {
        _vm.initData = $$v
      },
      expression: "initData"
    }
  }, _vm._l((_vm.initData), function(item, index) {
    return _c('div', {
      staticClass: "component-control"
    }, [(item.name === 'poster') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-slider"
      }
    })]), _vm._v("\n\t\t\t\t\t\t图片\n          ")] : _vm._e()], 2)
  }), 0)], 1), _vm._v(" "), _c('section', {
    staticClass: "section section-white view-warp el-row"
  }, [_c('div', {
    staticClass: "template-view el-col el-col-16"
  }, [_c('div', {
    staticClass: "template"
  }, [_c('draggable', {
    staticClass: "components-wrap",
    style: ('height: ' + (_vm.wheight - 220) + 'px;'),
    attrs: {
      "options": _vm.dragViewOptions
    },
    on: {
      "start": _vm.onStart,
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.components),
      callback: function($$v) {
        _vm.components = $$v
      },
      expression: "components"
    }
  }, _vm._l((_vm.components), function(widget, k) {
    return (_vm.renderable) ? _c(widget.name, {
      key: widget.uuid,
      tag: "component",
      class: [k == _vm.editorIndex ? 'active' : '', 'component-item'],
      attrs: {
        "data-uuid": widget.uuid,
        "data": widget
      },
      nativeOn: {
        "click": function($event) {
          return _vm.setCurrent(k)
        }
      }
    }, [_c('transition', {
      attrs: {
        "name": "el-fade-in-linear"
      }
    }, [(k == _vm.editorIndex) ? _c('div', {
      staticClass: "iconfont icon-trash-alt1",
      on: {
        "click": _vm.removeCurrent
      }
    }) : _vm._e()])], 1) : _vm._e()
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "setting-view el-col el-col-8"
  }, [(_vm.editorIndex === null) ? _c('div', {
    staticClass: "view-placeholder"
  }, [_c('i', {
    staticClass: "iconfont icon-shapes"
  }), _vm._v("\n          请选择左侧挂件\n        ")]) : [(_vm.renderable) ? _c(_vm.components[_vm.editorIndex].name + 'Style', {
    tag: "component",
    attrs: {
      "data": _vm.editorData,
      "data-uuid": _vm.components[_vm.editorIndex].uuid
    },
    on: {
      "update:data": function($event) {
        _vm.editorData = $event
      }
    }
  }) : _vm._e()]], 2)]), _vm._v(" "), _c('section', {
    staticClass: "content-padded-s section-white content-center"
  }, [_c('el-button', {
    staticClass: "btn-save",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveConfig
    }
  }, [_vm._v("保存")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f6dfe356", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6dfe356"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/vipPage/default.vue
// module id = 2986
// module chunks = 0